export const downloadGetFileResult = (response) => {
    const blob = response.data;
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = `${url}#filename=${encodeURIComponent(response.filename)}`;
    link.download = response.filename;
    link.click()
    window.URL.revokeObjectURL(url);
}